/** Join SPA paths without making an empty basename into a network-path URL. */
export function withAppBase(path: string, base: string): string {
  if (!path.startsWith('/') || path.startsWith('#')) return path;
  const prefix = base.replace(/^\/+|\/+$/g, '');
  const route = '/' + path.replace(/^\/+/, '');
  if (!prefix || route === `/${prefix}` || route.startsWith(`/${prefix}/`)) return route;
  return `/${prefix}${route}`;
}

export function withoutAppBase(path: string, base: string): string {
  const prefix = base.replace(/^\/+|\/+$/g, '');
  if (!prefix) return path;
  if (path === `/${prefix}`) return '/';
  return path.startsWith(`/${prefix}/`) ? path.slice(prefix.length + 1) : path;
}
